<ion-content>
  <ion-list *ngIf="notifications && notifications?.length > 0 ; else notificationsEmpty">
    <ion-item *ngFor="let notifi of notifications">
      <div class="noti-div">
        <p class="subtitle">{{notifi.notificationText}}</p>
        <p class="date">{{notifi.createdDate | date: 'dd/MM/yyyy hh:mm a'}}</p>
      </div>
    </ion-item>
    
  </ion-list>
  <ion-infinite-scroll *ngIf="notifications?.length" (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content loadingText="Please wait..."
      loadingSpinner="bubbles"></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <ng-template #notificationsEmpty>
    <ion-item>
      <ion-card-content>
         Notification list is empty
      </ion-card-content>
    </ion-item>
  </ng-template>
</ion-content>
